<template>

  <div>
    <b-modal
      v-model="modalOpen"
      footer-class="removed"
      centered
      no-close-on-backdrop
      v-bind="$attrs"
      v-on="$listeners"
      size="xl"
      title="إستعلام عن المعاملة"
    >
      <slot name="body">
          <b-row>
            <b-col cols="3" style="border-left: 1px solid #eee;">
              <p> إستعلام بحسب : </p>
              <hr />
              <form-autocomplete
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                v-model="searchKey.ngo_id"
                ep="v2/guest/filter-name"
                id="ngos"
                filterKey="name"
                label="اسم المنظمة"
              />
              
              <form-input
                v-model="searchKey.transaction_request_id"
                label="رقم المعاملة"
              />
              
              <form-select
                label="حالة المعاملة"
                id="status-role"
                :getOptionLabel="(x) => x.name"
                :reduce="(x) => x.value"
                :options="[
                  {name :'قيد معالجة' , value : 'open'},
                  {name :'بحاجة استدراك' , value : 'need_review'},
                  {name :'مقبولة' , value : 'accepted'},
                ]"
                v-model="searchKey.status"
              />
              
              <label for="obj">تاريخ تقديم المعاملة</label>
              <form-mask
                options="date"
                placeholder="YYYY-MM-DD"
                style="height: 37.5px !important"
                v-model="searchKey.created_at"
                class="w-25"
              />
              <form-select
              label="نوع المعاملة"
                v-model="searchKey.transaction_type_id"
                :getOptionLabel="(x) => x.name"
                :reduce="(x) => x.id"
                id="programs"
                ep="v2/ministry/selects/transaction-types"
                ref="programs"
                class="my-0"
              />
              
              <form-select
                label="المحافظة*"
                v-model="searchKey.selectedGov"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                id="sgovernorate"
                ep="v2/guest/selects/governorates"
                rules="required"
              />
              <div class="d-flex justify-content-end my-2">

                <b-button class="" @click="resetSearch">
                  <feather-icon icon="XIcon" class="mr-50" />
                  إلغاء البحث
                </b-button>
              </div>

            </b-col>
            <b-col cols="9">
              <data-table
                id="transactionInquiry-table"
                ep="v2/ministry/inquiry-about-transactions"
                :fields="fields"
                ref="TransactionInquiry"
                striped
                
              >
              
                <template #cell(status)="{ value }">
                  <transactions-status-formatter :value="value" />
                  <!-- <b-badge variant="secondary"> {{ value }} </b-badge> -->
                </template>
                <template #cell(created_at)="{ value }">
                  <span
                    >{{ value ? $moment(value).format("DD-MM-YYYY") : "" }}
                  </span>
                </template>
                <template #cell(updated_at)="{ value }">
                  <span
                    >{{ value ? $moment(value).format("DD-MM-YYYY") : "" }}
                  </span>
                </template>
                <template #cell(actions)="{ item }">
                  <div class="d-flex justify-content-start">
                    <template
                    >
                      <b-button
                        
                        @click="$router.push({ path: `accreditation-transactions/${item.id}` })"
                        
                        variant="flat-success"
                        class="mx-50"
                        > 
                        <feather-icon class="mx-25" icon="EyeIcon" />
                        عرض المعاملة
                      </b-button>
                    </template>
                  </div>
                </template>
              </data-table>
            </b-col>
          </b-row>
      </slot>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal,
  BRow,
  BCol,
  BForm,
  BButton,
  BSidebar,
  BFormCheckbox,
} from "bootstrap-vue";
import formAutocomplete from "@/components/form-autocomplete";
import FormSelect from "@/components/form-select";
import FormMask from "@/components/form-mask";
import FormInput from "@/components/form-input";
import DataTable from "@/components/data-table";
import { ValidationObserver } from "vee-validate";
import debounce from "lodash.debounce";
import TransactionsStatusFormatter from "@/modules/ngo/transactions/components/TransactionsStatusFormatter.vue";

export default {
  props: {
    value: Boolean,
  },
  components: {
    BModal,
    BRow,
    BCol,
    ValidationObserver,
    BForm,
    BButton,
    BSidebar,
    BFormCheckbox,
    formAutocomplete ,
    FormSelect ,
    FormMask , 
    FormInput , 
    DataTable ,
    TransactionsStatusFormatter

  },
  data() {
    return {
      form: {},
      isFormValid: true,
      searchKey: {},
      fields: [
        { label: "المعرف", key: "id" },
        { label: "نوع المعاملة", key: "transactionType.name" },
        { label: "حالة المعاملة", key: "status" },
        { label: "تاريخ تقديم المعاملة", key: "created_at" },
        { label: "الأوامر" , key : "actions"}
       
      ],
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    // ep(){
    //   return Object.keys(this.searchKey).length === 0 ? "" : "v2/ministry/inquiry-about-transactions"
    // }
  },
  watch: {
    modalOpen(val) {
      if (!val) {
        requestAnimationFrame(() => {
          this.searchKey = {};
          this.$refs.FormValidation.reset();
        });
      }
    },
    searchKey: debounce(function (value) {
      this.$refs.TransactionInquiry.setQueryParams({
        ...this.searchKey ,
      });
      this.$refs.TransactionInquiry.refreshTable();
    }, 300),
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
      console.log("this.form" , this.form)
    },
    async onSubmit() {
      await this.$refs.FormValidation.validate().then(async (success) => {
        if (success) {
          if (this.isFormValid) this.$emit("confirm", this.form);
        }
      });
    },
    resetSearch(){
      this.searchKey = {}
    }
  },
};
</script>
